<span fxLayout="column" fxFlex="0 1 900px" fxFill fxLayoutAlign="center start"
      id="feature-{{feature?.previewItem?.id}}">
      <span fxLayout="column" fxLayoutGap="20px" class="res-pad-lr-0-20" fxFill>
            <span class="mat-headline-1 primary-color overline-margin">{{feature?.previewItem?.topos}}</span>
            <h2 class="mat-headline-2 overline-title-gap m-0">{{feature?.previewItem?.title}}</h2>
            <span fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="40px" fxFill fxFlexAlign="start start"
                  class="special-img-border" fxFlexOffset="30px">
                  <img class="object-fit-cover mb-4" [src]="feature?.previewItem?.imagehigh | safe : 'resourceUrl'"
                        class="res-height-262-204" [ngClass]="{'imgWidthMobile': isXs}" loading="lazy" fetchprioritiy="low"
                        [alt]="
                        !!feature?.previewItem?.title
                          ? feature.previewItem?.title + ' - ' + ('extra.image' | translate)
                          : ('extra.section' | translate) +
                            ' - ' +
                            ('extra.image' | translate)
                      "
                        />
                  <span fxLayout="column" fxFlex fxFlex.sm="1 0 320px" fxFlex.xs="100" fxLayoutGap="20px"
                        fxLayoutAlign="start">
                        <span class="mb1">{{feature?.previewItem?.summary}}</span>

                        <a *ngIf="feature?.button?.uri != null" class="mt-1 d-flex text-decoration-none black"
                              fxFlex="36px" fxLayout="row" fxLayoutAlign="center center"
                              [routerLink]="[feature?.button?.uri]">
                              <div fxFlex="0 0 160px" fxLayoutAlign="center center"
                                    class="align-self-center font-weight-bold flimmo-outline-button">
                                    {{feature?.button?.label}}</div>
                        </a>
                  </span>
            </span>
      </span>
      <swimlanes fxFlexOffset="40px" [swimlane]="feature?.swimlane"></swimlanes>

</span>
